<div class="chart-container">
    <canvas *ngIf="data" baseChart [data]="chartData" [type]="chartType" [options]="chartOptions" [legend]="showLegend"></canvas>
</div>